import { Component, EventEmitter, Input, Output } from '@angular/core';

export type AccordionListItem = {
  id: string | number;
  label: string;
  content: string;
};

@Component({
  selector: 'accordion-list',
  standalone: false,
  styleUrls: ['./accordion-list.component.scss'],
  templateUrl: './accordion-list.component.html',
})
export class AccordionListComponent {
  @Input() public items: AccordionListItem[] = [];
  @Input() public expand: 'compact' | 'inset' = 'compact';
  @Input() public value: string | number | undefined;
  @Output() public valueChange = new EventEmitter<string | number | undefined>();

  public onAccordionGroupChanged(ev: CustomEvent<{ value: string | number | undefined }>): void {
    this.value = ev.detail.value;
    this.valueChange.emit(this.value);
  }
}
